module.exports = __webpack_public_path__ + "img/red_059.42e52a37.png";